import React, { useState, useEffect } from 'react';

const ROLES = ['Victim', 'Witness', 'Accomplice', 'Other'];

function AssociatedPersonForm({ onSubmit, initialData = {}, onCancel }) {
  const [formData, setFormData] = useState({
    full_name: '',
    role: 'Witness',
    phone: '',
    statement: '',
  });

  const isEditing = !!initialData.id;

  useEffect(() => {
    if (isEditing) {
      setFormData({
        full_name: initialData.full_name || '',
        role: initialData.role || 'Witness',
        phone: initialData.contact_info?.phone || '',
        statement: initialData.statement || '',
      });
    }
  }, [initialData, isEditing]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { phone, ...rest } = formData;
    const finalData = {
      ...rest,
      contact_info: { phone },
    };
    onSubmit(finalData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
        <form onSubmit={handleSubmit} className="p-6">
          <h2 className="text-xl font-bold text-slate-800 mb-4">{isEditing ? 'Edit' : 'Add'} Associated Person</h2>
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Full Name</label>
                <input type="text" name="full_name" value={formData.full_name} onChange={handleChange} required />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Role</label>
                <select name="role" value={formData.role} onChange={handleChange}>
                  {ROLES.map(role => <option key={role} value={role}>{role}</option>)}
                </select>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Phone Number</label>
              <input type="text" name="phone" value={formData.phone} onChange={handleChange} />
            </div>
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Statement / Notes</label>
              <textarea name="statement" value={formData.statement} onChange={handleChange} rows="4" />
            </div>
          </div>
          <div className="flex justify-end gap-4 pt-4 mt-6 border-t border-slate-200">
            <button type="button" onClick={onCancel} className="bg-slate-200 text-slate-700 hover:bg-slate-300 font-bold py-2 px-4 rounded-lg">Cancel</button>
            <button type="submit" className="bg-gold text-white hover:bg-gold-dark font-bold py-2 px-4 rounded-lg">Save Person</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AssociatedPersonForm;